import { RUN_TYPE_LABELS, resolveDaySessionKind, SESSION_KINDS } from './trainingSportSession';
import { weekdayLabel } from './trainingWeekday';

function firstToken(raw) {
  const t = String(raw || '').trim();
  if (!t) return '';
  return t.split(/\s+/)[0];
}

function stripDayPrefix(nombre) {
  return String(nombre || '').replace(/^Día\s*\d+\s*[·:.\-–]\s*/i, '').trim();
}

/** Nombre con el que el coach le habla al atleta (Jabel, no la razón social completa). */
export function coachSpokenName({ trainer, branding } = {}) {
  const person = String(trainer?.nombre || trainer?.name || branding?.nombre || '').trim();
  if (person) return firstToken(person);
  const brand = String(branding?.brand_name || '').trim();
  if (brand) return firstToken(brand);
  return '';
}

export function athleteFirstName(user) {
  return firstToken(user?.nombre || user?.name || user?.first_name || '');
}

/** Resumen de la semana asignada, para que el atleta vea qué toca cada día. */
export function summarizeAssignedWeek(dias = []) {
  return (Array.isArray(dias) ? dias : []).map((d) => {
    const kind = resolveDaySessionKind(d);
    const wd = weekdayLabel(d.weekday);
    const title = stripDayPrefix(d.nombre);
    const rx = d.sport_prescription || {};
    let detail = title;
    if (kind === SESSION_KINDS.RUNNING) {
      const rt = RUN_TYPE_LABELS[rx.run_type] || title || 'Running';
      const km = Number(rx.distance_target_km);
      detail = Number.isFinite(km) && km > 0 ? `${rt} · ${km} km` : rt;
    } else if (kind === SESSION_KINDS.SWIMMING) {
      detail = title || 'Natación';
    } else if (!detail) {
      const n = (d.ejercicios || []).filter((ex) => {
        const name = String(ex.exercise_name || '').toLowerCase();
        return name && !name.includes('calentamiento');
      }).length;
      detail = n ? `Gimnasio · ${n} ejercicios` : 'Gimnasio';
    }
    return {
      dia: d.dia,
      weekday: wd,
      kind,
      label: wd ? `${wd} · ${detail}` : (detail || `Día ${d.dia}`),
      hasNotes: Boolean(String(d.coach_notes || '').trim()),
    };
  });
}
